/**
 * @fileoverview Explore Khanmigo component for the courses menu. Currently is
 * displayed as a pinned link in the main menu. In the future, this may be
 * changed to have a submenu panel with more tools depending on the user's
 * role.
 */
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import Link from "@khanacademy/wonder-blocks-link";
import {LabelMedium} from "@khanacademy/wonder-blocks-typography";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";
import {doNotTranslateYet} from "@khan/i18n";
import {useLocation} from "@khan/urls";

import {coursesMenuCoreStyles as styles} from "./shared-styles.ts";
import type {ItemsType} from "./types.ts";

import externalLinkIcon from "@phosphor-icons/core/bold/arrow-square-out-bold.svg";

type Props = {
    // The position index of the link in the main menu
    posIdx: number;
    // The ref object for the main menu items
    mainItemRefs: React.MutableRefObject<ItemsType>;
    // Whether the link is selected
    isSelected: boolean;
};

export const ExploreKhanmigo = ({
    posIdx,
    mainItemRefs,
    isSelected,
}: Props): React.ReactElement | null => {
    const href = "https://www.khanmigo.ai/";
    const translatedTitle = doNotTranslateYet`Explore Khanmigo`;
    const location = useLocation();
    const publishAnalyticsEvent = usePublishAnalyticsEvent();

    const handleOnClick = async () => {
        await publishAnalyticsEvent({
            eventType: "NavBarCourseMenuKhanmigoClicked",
            currentPageUrlPath: location.pathname,
            eventSchemaVersion: 1,
        });
    };

    return (
        // Parent provides the <li>; avoid nested list items here
        <Link
            safeWithNav={handleOnClick}
            href={href}
            style={styles.menuItem}
            target="_blank"
            endIcon={<PhosphorIcon icon={externalLinkIcon} size="small" />}
            ref={(node: HTMLAnchorElement) => {
                mainItemRefs.current[posIdx] = node;
            }}
            role="menuitem"
            tabIndex={isSelected ? 0 : -1}
        >
            <LabelMedium style={styles.pinnedLinkText}>
                {translatedTitle}
            </LabelMedium>
        </Link>
    );
};
